const API_URL = process.env.REACT_APP_EP_API;

export function getSubdomain() {
  const hostname = window.location.hostname;

  if (hostname.endsWith('murmuratto.com') || hostname.endsWith('murmuratto.app')) {
    const parts = hostname.split('.');
    if (parts.length > 2) {
      return parts.slice(0, -2).join('.');
    }
  }

  return 'demo';
}

export function isOnMurmurattoCom() {
  return window.location.hostname.endsWith('murmuratto.com');
}

export async function checkIfG3Company(companyCode) {
  if (!companyCode || companyCode === 'demo') {
    return false;
  }

  try {
    const response = await fetch(`${API_URL}/public/validate-company/${companyCode}`);
    if (!response.ok) {
      return false;
    }
    const data = await response.json();
    return data.exists === true && data.g3 === true;
  } catch (error) {
    console.error('Error checking G3 company:', error);
    return false;
  }
}

export async function redirectToG3IfNeeded() {
  if (!isOnMurmurattoCom()) {
    return false;
  }

  const subdomain = getSubdomain();
  if (subdomain === 'demo') {
    return false;
  }

  const isG3 = await checkIfG3Company(subdomain);
  if (isG3) {
    window.location.href = `https://${subdomain}.murmuratto.app`;
    return true;
  }

  return false;
}
